import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/core/authentication/auth.service';
// import { environment } from '@environments/environment';
import { UiService } from 'app/core/services/ui.service';
import { MessageBoxParameter } from '@classes/message-box-parameter';
import { MessageBox } from '@components/message-box/message-box.component';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { MenuItem, MenuItemPath } from '@enums/menu-item.enum';
import { EnvConfigurationService } from 'app/core/services/env-configuration.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss'],
  styles: [`
  >>> app-forget-password {
    height: 100%;
    display: flex;
  }
`]
})
export class ForgetPasswordComponent implements OnInit {
  environment = this.envConfigurationService.environment;

  forgetPasswordForm!: FormGroup;

  isLoading: boolean = false;
  guid: string;

  hide = true;
  environmentName = this.environment.application;

  constructor(
    private authSrv: AuthService,
    private fb: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    public envConfigurationService: EnvConfigurationService
  ) { }

  ngOnInit() {
    if (!this.authSrv.isAuth()) {
      this.getRouteParams();
    }
    this.initForm();
  }

  private initForm(): void {
    this.forgetPasswordForm = this.fb.group({
      newPassword: new FormControl(null, [Validators.required]),
    });
  }
  private getRouteParams(): void {
    this.guid = this.route.snapshot.queryParams.guid;

  }

  onSubmit(): void {
    if (this.forgetPasswordForm.valid) {
      this.isLoading = true;
      this.authSrv.changeForgetPassword(this.guid, this.forgetPasswordForm.value.newPassword).subscribe((success) => {
        this.router.navigate(['/']);
      }, (error) => {
        this.isLoading = false;
      }, () => {
        this.isLoading = false;
      }
      );
    }
  }

  onBackClick() {
    this.router.navigate([MenuItemPath.get(MenuItem.home)]);
  }
}
